export default "__VITE_ASSET__Cpr8GoWM__"